import { createApp } from 'vue'
import { createPinia } from 'pinia'

import QualityFeedbackForm from '@/src/javascripts/quality_feedbacks/QualityFeedbackForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const qualityFeedbackForm = document.querySelector('#quality-feedback-form')

  if (qualityFeedbackForm && !qualityFeedbackForm.__vue_app__) {
    const pinia = createPinia()
    const app = createApp({
      components: { QualityFeedbackForm, BaseAlert }
    })

    app.use(pinia)
    app.mount(qualityFeedbackForm)
  }
})
